var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linkable",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"iconBtn transition",class:{'opened': _vm.open === true},attrs:{"src":"/clientV2/static/gfx/ArrowCircle.svg"}}),_vm._v("\n  "+_vm._s((_vm.open === false) ? _vm.showText : _vm.hideText)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d592f082","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/uiMoreButton.vue
// module id = q98O
// module chunks = 66